export default __webpack_public_path__ + "static/media/step14.4a749b36.svg";